module.exports = __webpack_public_path__ + "static/media/gsclogo-inverse.c7bcffc7.png";